import { render, staticRenderFns } from "./GraphTable.vue?vue&type=template&id=2728b516&"
import script from "./GraphTable.vue?vue&type=script&lang=js&"
export * from "./GraphTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports